import dayjs from "dayjs";
import { supabase } from "../../config/supabaseClient";
import { UpdateCombinedText } from "../SupabaseServices/ContentDatabase";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { TRACKING_TYPES } from "../SupabaseServices/Track";
import trackEmbed, {
  TRACKING_EMBED_TYPES,
} from "../SupabaseServices/TrackEmbed";
import track from "../SupabaseServices/Track";
import { getWeekDate } from "../HelperFunction/TimezoneDates";
import { getPublicUrl, getPublicUrlWithUsername } from "../CustomDomain/CustomDomainFuntions";

dayjs.extend(utc);
dayjs.extend(timezone);
const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const daysSinceMultipleDays = (targetDaysOfWeek: number[]) => {
  const currentDayOfWeek = getWeekDate();
  const daysSinceTargetDays = targetDaysOfWeek.map(
    (targetDayOfWeek) => (currentDayOfWeek - targetDayOfWeek + 7) % 7
  );
  return daysSinceTargetDays;
};

export const isNavigable = (component: any) => {
  return (
    component.display_name !== "My Links" &&
    !component.display_name.includes("Form") &&
    component.type !== "banner" &&
    component.type !== "highlight" &&
    component.type !== "links-section" &&
    component.type !== "embed-form" &&
    !component.display_name.includes("Newsletter")
  );
};

export function redirectToUrl(data: any, isLinks: any) {
  const redirectUrl = !isLinks
    ? data?.shop_link ||
      data?.external_link ||
      data?.permalink ||
      data?.table_url
    : data?.shop_link ||
      data?.table_url ||
      data?.external_link ||
      data?.permalink;
  const finalRedirectUrl = addHttpToLink(redirectUrl);
  return finalRedirectUrl;
}
export async function updateIsEmptyStatus(name: any, user_id: any, id: any) {
  const { data, error } = await supabase
    .from("stayuptodate_components")
    .update({ isEmpty: true })
    .eq("name", name)
    .eq("id", id)
    .eq("user_id", user_id);
}
export async function updateCardImage(
  name: any,
  user_id: any,
  id: any,
  image: any
) {
  const { data, error } = await supabase
    .from("stayuptodate_components")
    .update({ card_image: image, isEmpty: false })
    .eq("name", name)
    .eq("id", id)
    .eq("user_id", user_id);
}

export function getMediaSrc(
  type: any,
  data: any,
  isCarousel: any,
  media_url: any
) {
  if (data?.media_url || data?.table_image) {
    if (isCarousel) {
      return media_url;
    } else {
      if (type !== "content" && type !== "query-content") {
        if (type === "product-bank") {
          return data?.media_url
            ? data?.media_url
            : data?.product_image
            ? data?.product_image
            : data?.table_image;
        } else {
          return data?.media_url.includes("video")
            ? data?.product_image
              ? data?.product_image
              : data?.thumbnail
            : data?.product_image
            ? data?.product_image
            : data?.media_url;
        }
      } else {
        return data?.media_url
          ? data?.media_url
          : data?.media_url.includes("video")
          ? data?.thumbnail
          : data?.product_image;
      }
    }
  } else if (data?.thumbnail) {
    return data?.thumbnail;
  } else {
    return "";
  }
}

export const testLink = (link: any) => {
  const url = link;
  if (url && url !== "") {
    // const validUrl = url.startsWith("http") ? url : `http://${url}`;
    const validUrl = addHttpToLink(url);
    window.open(validUrl, "_blank");
  }
};

export async function updateNameValues(
  username: string,
  type: any,
  post_id: any,
  user_id: any,
  value: any
) {
  if (type === "content" || type === "query-content") {
    const { data: user, error } = await supabase
      .from(`${username}`)
      .update({ content_title: value })
      .eq("post_id", post_id)
      .eq("user_id", user_id);
    const { data: newProduct, error: newProductErroor } = await supabase
      .from("product_bank")
      .update({ content_title: value })
      .eq("product_id", post_id)
      .eq("user_id", user_id);
  } else {
    const { data: user, error } = await supabase
      .from(`${username}`)
      .update({ shop_title: value, product_name: value })
      .eq("post_id", post_id)
      .eq("user_id", user_id);
    const { data: newProduct, error: newProductErroor } = await supabase
      .from("product_bank")
      .update({ shop_title: value })
      .eq("product_id", post_id)
      .eq("user_id", user_id);
  }

  const { data: newContent, error: newErroor } = await supabase
    .from("content_new")
    .update({ product_name: value })
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  UpdateCombinedText(username, user_id, post_id);
}

export const formatDateToString = (date: Date): string => {
  return date.toISOString().split("T")[0];
};

// Function to get all dates from a day selection (handles "This Weekend" specially)
export const getAllDatesFromSelection = (selectedDays: string[]): string[] => {
  const allDates: string[] = [];

  selectedDays.forEach((day) => {
    const dateResult = getMostRecentDayDate(day);

    if (dateResult) {
      if (Array.isArray(dateResult)) {
        // For "This Weekend", add both Saturday and Sunday dates
        dateResult.forEach((date) => {
          allDates.push(formatDateToString(date));
        });
      } else {
        allDates.push(formatDateToString(dateResult));
      }
    }
  });

  // Remove duplicates and sort in ascending order
  return [...new Set(allDates)].sort();
};

export const getMostRecentDayDate = (dayName: string): Date | Date[] | null => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const today = new Date();
  const todayDayIndex = today.getDay(); // 0-6, where 0 is Sunday

  // Handle "This Weekend" specially - return both Saturday and Sunday
  if (dayName === "This Weekend") {
    // For "This Weekend", return an array of [Saturday, Sunday]
    const lastWeekend = [];

    // Get the most recent Saturday
    const lastSaturday = new Date(today);
    if (todayDayIndex === 0) {
      // Today is Sunday
      lastSaturday.setDate(today.getDate() - 1); // Yesterday was Saturday
    } else if (todayDayIndex === 6) {
      // Today is Saturday
      // Keep today's date for Saturday
    } else {
      // Set to last Saturday
      lastSaturday.setDate(today.getDate() - todayDayIndex - 1);
    }

    // Get the most recent Sunday
    const lastSunday = new Date(today);
    if (todayDayIndex === 0) {
      // Today is Sunday
      // Keep today's date for Sunday
    } else {
      // Set to last Sunday
      lastSunday.setDate(today.getDate() - todayDayIndex);
    }

    return [lastSaturday, lastSunday];
  }

  const targetDayIndex = days.indexOf(dayName);
  if (targetDayIndex === -1) return null;

  let daysAgo = todayDayIndex - targetDayIndex;
  if (daysAgo < 0) {
    daysAgo += 7; // If the day is ahead in the week, go back to previous week
  }

  const recentDate = new Date(today);
  recentDate.setDate(today.getDate() - daysAgo);

  return recentDate;
};

export const addHttpToLink = (link: string) => {
  if(link){
    return link?.startsWith("http") ? link : `https://${link}`;
  }
  return "";
};

export function formatPostDate(utcDateStr: any) {
  const userTZ = userTimeZone;

  // Format dates for different timezones
  const utcDate = dayjs.utc(utcDateStr);

  const formattedDates = {
    utc: utcDate.format("MMM D, YYYY"),
    local: utcDate.tz(userTZ).format(`MMM D, YYYY`),
    ist: utcDate.tz("Asia/Kolkata").format("MMM D, YYYY"),
    newYork: utcDate.tz("America/New_York").format("MMM D, YYYY"),
  };

  // --------old way --------
  {
    /* {new Intl.DateTimeFormat("en-US", {
                                year: "numeric",
                                day: "numeric",
                                month: "long",
                              }).format(new Date(image.post_date))} */
  }
  // ------------

  return formattedDates.local;
}

export const DuplicateNameError = () => {
  return "That name’s already taken. Try something unique to avoid confusion.";
};

export const reactQueryParams = () => {
  return {
    retry: 1,
    refetchOnWindowFocus: false,
  };
};

export const handleNavigate = (
  navigate: any,
  location: any,
  username: any,
  user_id: any,
  component: any,
  from: any
) => {
  if (isNavigable(component)) {
    // navigate(`/${username}/${component.route_name || component.unique_id}`, {
    //   state: { data: component, from: from },
    // });
    navigate(
      getPublicUrlWithUsername(username, component.route_name || component.unique_id),
      {
        state: { data: component, from: from },
      }
    );
    
    if (from === "embed-search") {
      trackEmbed("Carousel Click", TRACKING_EMBED_TYPES.EVENT, {
        pathname: location.pathname,
        details: {
          unique_id: component?.unique_id,
          type: component?.type,
          title: component.name,
        },
        user_id: user_id,
        title: "Stay Up To Date",
      });
    } else {
      track("Carousel Click", TRACKING_TYPES.EVENT, {
        pathname: location.pathname,
        details: {
          unique_id: component?.unique_id,
          type: component?.type,
          title: component.name,
        },
        user_id: user_id,
        title: "Stay Up To Date",
      });
    }
  }
};




export function handleFirstImage(name: any, id: any, firstElement: any,user_id:any) {
  const imageToSend =
    firstElement?.table_image ||
    (firstElement?.media_url?.includes("video")
      ? firstElement?.thumbnail
      : firstElement?.media_url);

  if (imageToSend) {
    updateCardImage(name, user_id, id, imageToSend);
  }
}


export   function handleEmptyCarousel(name: any, id: any,user_id:any) {
  updateIsEmptyStatus(name, user_id, id);
}



export  const getPlaceholderText = (name:any,hasConnectedContentPlatform:any,hasConnectedAffiliatePlatform:any) => {
  if (hasConnectedContentPlatform && hasConnectedAffiliatePlatform) {
    return "Search "+name+" content and products!";
  } else if (hasConnectedContentPlatform) {
    return "Search "+name+" content!";
  } else if (hasConnectedAffiliatePlatform) {
    return "Search "+name+" products!"
  } else {
    return `Search ${name} Content`;
  }
};